const KEY = 'h150_player';

export const playerSession = {
  get() {
    for (const storage of [localStorage, sessionStorage]) {
      try {
        const value = JSON.parse(storage.getItem(KEY) || 'null');
        if (value?.participantId && value?.playerToken && value?.sessionId && value?.pin) return value;
      } catch {}
    }
    return null;
  },

  save(player) {
    localStorage.setItem(KEY, JSON.stringify(player));
    sessionStorage.setItem(KEY, JSON.stringify(player));
  },

  clear() {
    localStorage.removeItem(KEY);
    sessionStorage.removeItem(KEY);
  }
};
